import * as React from 'react';
import { Header1 } from '@cian/ui-kit';
import { Mortgage as MortgageComponent } from '../../components/Mortgage';
import { MortgageCalculator } from '../MortgageCalculator';

export function Mortgage() {
  return <MortgageComponent title={<Header1>Рассчитать ипотеку</Header1>} calculator={<MortgageCalculator />} />;
}
